define([
    'lib/tentacle/tentacle',
    'modules/common/controls/control',
    'modules/common/controls/input',
    'modules/common/controls/textarea',
    'modules/common/controls/typewatchinput',
    'modules/common/controls/numericinput',
    'modules/common/controls/numericelement',
    'modules/common/controls/barecheckbox',
    'modules/common/controls/checkbox',
    'modules/common/controls/select2',
    'modules/common/controls/date',
    'modules/common/controls/datepicker',
    'modules/common/controls/datetimepicker',
    'modules/common/controls/checklist',
    'modules/common/controls/radiolist',
    'modules/common/controls/checklistmodal',
    'modules/common/controls/tabselect',
    'modules/common/controls/pillslist',
    'modules/common/controls/buttongroup',
    'modules/common/controls/label'
], (Tentacle, Control, Input, TextArea, TypeWatchInput, NumericInput, NumericElement, BareCheckBox, CheckBox,
    Select2, DateControl, DatePicker, DateTimePicker, CheckList, RadioList, CheckListModal, TabSelect,
    PillsList, ButtonGroup, Label) => {

    Tentacle.registerControls({
        control: Control,
        input: Input,
        textarea: TextArea,
        typewatchinput: TypeWatchInput,
        numeric: NumericElement,
        numericinput: NumericInput,
        barecheckbox: BareCheckBox,
        checkbox: CheckBox,
        select2: Select2,
        date: DateControl,
        datepicker: DatePicker,
        datetimepicker: DateTimePicker,
        checklist: CheckList,
        radiolist: RadioList,
        checklistModal: CheckListModal,
        tabselect: TabSelect,
        pillsList: PillsList,
        buttonGroup: ButtonGroup,
        label: Label
    });

});
